/**
 * A full-screen wait.
 *
 * Centred in the viewport rather than pinned to the top, because a lone line of
 * text under a header reads like a mistake rather than a moment of patience.
 *
 * The spinner is a CIRCLE with an explicit width and height. That sounds
 * obvious; an earlier version of this project shipped a "spinner" that was a
 * wide rectangle with one coloured edge, and it swept across the screen like a
 * windscreen wiper. Fixed square dimensions plus `border-radius: 50%` are what
 * make it a ring, and both halves are load-bearing.
 */
export function Loading({ label, hint }: { label: string; hint?: string }) {
  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <p className="loading-label">{label}</p>
      {hint && <p className="loading-hint">{hint}</p>}
    </div>
  );
}
